import { defineMessages } from 'react-intl';

export const LOCATION_CARD_KEY = '@@locationCard';

export const Sections = {
    AcceptsNewPatients: 'AcceptsNewPatients',
    AgeRestriction: 'AgeRestriction',
    Tier: 'Tier',
    HandicapAccessible: 'HandicapAccessible',
    WheelchairAccessible: 'WheelchairAccessible',
    ProvenHealthNavigatorLocation: 'ProvenHealthNavigatorLocation',
    GHPExtraSite: 'GHPExtraSite',
    PhoneNumber: 'PhoneNumber',
    FaxNumber: 'FaxNumber',
    OfficeHours: 'OfficeHours',
};

export const LOCALIZED_STRINGS = defineMessages({
    ShowMore: {
        id: 'Components.LocationCard.ShowMore',
        defaultMessage: 'view more info',
    },
    ShowLess: {
        id: 'Components.LocationCard.ShowLess',
        defaultMessage: 'view less info',
    },
    [Sections.PhoneNumber]: {
        id: 'Components.LocationInfo.Phone',
        defaultMessage: 'Phone',
    },
    [Sections.HandicapAccessible]: {
        id: 'Components.LocationInfo.HandicapAccessible',
        defaultMessage: 'Handicap accessible',
    },
    [Sections.FaxNumber]: {
        id: 'Components.LocationInfo.Fax',
        defaultMessage: 'Fax',
    },
    [Sections.WheelchairAccessible]: {
        id: 'Components.LocationInfo.WheelchairAccessible',
        defaultMessage: 'Wheelchair accessible',
    },
    [Sections.OfficeHours]: {
        id: 'Components.LocationInfo.OfficeHours',
        defaultMessage: 'Office hours',
    },
    [Sections.Tier]: {
        id: 'Components.LocationInfo.Tier',
        defaultMessage: 'Tier',
    },
    [Sections.ProvenHealthNavigatorLocation]: {
        id: 'Components.LocationInfo.ProvenHealthNavigatorLocation',
        defaultMessage: 'ProvenHealth Navigator location',
    },
    [Sections.GHPExtraSite]: {
        id: 'Components.LocationInfo.GHPExtraSite',
        defaultMessage: 'GHP Extra site',
    },
    Yes: {
        id: 'Components.LocationInfo.Yes',
        defaultMessage: 'Yes',
    },
    No: {
        id: 'Components.LocationInfo.No',
        defaultMessage: 'No',
    },
    [Sections.AcceptsNewPatients]: {
        id: 'Components.LocationInfo.AcceptsNewPatients',
        defaultMessage: 'Accepts new patients',
    },
    [Sections.AgeRestriction]: {
        id: 'Components.LocationInfo.AgeRestriction',
        defaultMessage: 'Patient age restriction',
    },
    GHPPrimaryCareProvided: {
        id: 'Components.LocationInfo.GHPPrimaryCareProvided',
        defaultMessage: 'Care and/or services offered by provider may vary based on location. Please contact office for details.',
    },
});

export const LOCALIZED_TOOLTIPS = defineMessages({
    [Sections.Tier]: {
        id: 'Components.LocationInfo.Tier.Tooltip',
        defaultMessage: 'The provider, location, and insurance plan are in this cost tier. This information is provided to the Health Plan by the provider and validated at least every three years or more frequently as updates are provided.',
    },
    [Sections.HandicapAccessible]: {
        id: 'Components.LocationInfo.HandicapAccessible.Tooltip',
        defaultMessage: 'Handicap accessibility. This information is provided to the Health Plan by the provider and validated at least every three years or more frequently as updates are provided.',
    },
    [Sections.WheelchairAccessible]: {
        id: 'Components.LocationInfo.WheelchairAccessible.Tooltip',
        defaultMessage: 'Wheelchair accessibility. This information is provided to the Health Plan by the provider and validated at least every three years or more frequently as updates are provided.',
    },
    [Sections.ProvenHealthNavigatorLocation]: {
        id: 'Components.LocationInfo.ProvenHealthNavigatorLocationTooltip',
        defaultMessage: 'This location offers specialized care and service to Geisinger Health Plan (GHP) members. With some of our plans such as GHP Extra, you may have a lower copayment for office visits at this location. Check your benefit documents to find out if you qualify.',
    },
    [Sections.GHPExtraSite]: {
        id: 'Components.LocationInfo.GHPExtraSiteTooltip',
        defaultMessage: 'This site qualifies for a lower Primary Care Physician (PCP) copay if your benefit plan includes one. See your ID card or Schedule of Benefits for details.',
    },
    [Sections.AcceptsNewPatients]: {
        id: 'Components.LocationInfo.AcceptsNewPatients.Tooltip',
        defaultMessage: 'Whether the provider is accepting new patients, existing patients only or is closed to new membership. This information is provided to the Health Plan by the provider and validated at least every three years or more frequently as updates are provided.',
    },
    [Sections.AgeRestriction]: {
        id: 'Components.LocationInfo.AgeRestriction',
        defaultMessage: 'Age range of patients the doctor sees. This information is provided to the Health Plan by the provider and validated at least every three years or more frequently as updates are provided.',
    },
});

export const MAP_SIZE_DESKTOP = 120;
export const MAP_SIZE_MOBILE = 64;
